import {
    faFacebook,
    faGooglePlus,
    faInstagram,
    faTelegram,
    faTiktok,
    faXTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Flex, Row, Typography } from 'antd';
import React, { useState } from 'react';
import './questions-block.scss';
import { localize } from '/react4xp/mixins/helpers';
import SubmitIcon from '/react4xp/parts/questions-block/icons/submit-icon.svg';
import { QuestionsBlock } from '/react4xp/parts/questions-block/questions-block.type';

function QuestionsBlock(props: QuestionsBlock.Props) {
    const [query, setQuery] = useState<string>('');

    const handleSubmitQuery = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!query.trim()) return;

        const openAssistantEvent = new CustomEvent('openAssistant');
        window.dispatchEvent(openAssistantEvent);
        const messageEvent = new CustomEvent('assistantMessage', { detail: { query } });
        setTimeout(() => {
            window.dispatchEvent(messageEvent);
        }, 300);
        setQuery('');
    };

    return (
        <div className="questions-block hide-on-mobile hide-on-tablet">
            <Row gutter={[16, 16]}>
                <Col
                    xs={24}
                    className="question"
                >
                    {localize('any-questions', props.translations)}
                </Col>

                <Col
                    xs={24}
                    lg={12}
                >
                    <Flex
                        vertical
                        gap={5}
                    >
                        <Typography.Text className={'question_item'}>
                            {localize('question_to_a_virtual_assistant', props.translations)}
                        </Typography.Text>

                        <form
                            className="form"
                            onSubmit={(e) => handleSubmitQuery(e)}
                        >
                            <input
                                className="input"
                                type="text"
                                placeholder={localize('question', props.translations)}
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                            <button
                                type="submit"
                                className="btn btn__submit"
                                style={{ width: '87px', borderRadius: '0 4px 4px 0' }}
                            >
                                <SubmitIcon />
                            </button>
                        </form>
                    </Flex>
                </Col>

                <Col
                    xs={24}
                    lg={12}
                >
                    <Flex
                        vertical
                        align={'center'}
                    >
                        <Typography.Text className="question_item">
                            {localize('social_networks_and_messengers', props.translations)}
                        </Typography.Text>

                        <Flex gap={15}>
                            <a
                                href="https://www.facebook.com/kgd.gov.kz/"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faFacebook}
                                    className="icon-color"
                                    style={{
                                        fontSize: 35,
                                    }}
                                />
                            </a>

                            <a
                                href="https://www.instagram.com/press_kyzmet_kgd/"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faInstagram}
                                    className="icon-color"
                                    style={{
                                        fontSize: 35,
                                    }}
                                />
                            </a>

                            <a
                                href="https://t.me/kgdmfrk"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faTelegram}
                                    className="icon-color"
                                    style={{
                                        fontSize: 35,
                                    }}
                                />
                            </a>

                            <a
                                href="https://twitter.com/KGD_MF_RK"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faXTwitter}
                                    className="icon-color"
                                    style={{
                                        fontSize: 35,
                                    }}
                                />
                            </a>

                            <a
                                href="https://www.youtube.com/@salykgovkz/featured"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faYoutube}
                                    className="icon-color"
                                    style={{
                                        fontSize: 35,
                                    }}
                                />
                            </a>

                            <a
                                href="https://plus.google.com/u/0/117682662040777385365/posts"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faGooglePlus}
                                    className="icon-color"
                                    style={{
                                        fontSize: 35,
                                    }}
                                />
                            </a>
                            <a
                                href="https://www.tiktok.com/@qr_mkk"
                                className="links"
                                target="_blank"
                            >
                                <FontAwesomeIcon
                                    icon={faTiktok}
                                    className="icon-color"
                                    style={{
                                        fontSize: 35,
                                    }}
                                />
                            </a>
                        </Flex>
                    </Flex>
                </Col>
            </Row>
        </div>
    );
}

export default QuestionsBlock;
